import Login from './Login.json';

const en = {
  Login,
};

export default en;
